import React, {forwardRef, useState} from 'react';
import RadioButton from '../../../ui/Forms/Inputs/RadioButton';
import RadioGroup from '../../../ui/Forms/Inputs/RadioGroup';
import {
  RatingGroup,
  RatingValueScale,
  ValuesList,
} from '../ProductReview.styled';

interface Props {
  values: string[];
  className?: string;
  name: string;
}

const HorizontalRatingGroup = forwardRef<HTMLInputElement, Props>(
  function StyledRatingGroup({values, name, className}, register) {
    const [currentValue, setCurrentValue] = useState(0);

    return (
      <RatingGroup className={className}>
        <ValuesList
          values={values}
          currentValue={currentValue}
          data-testid={`review-horizontalGroup-${name}-current`}
        />
        <RadioGroup spaceBetween>
          {values.map((title, index) => {
            return (
              <RadioButton
                data-testid={`review-radio-${name}-${index + 1}`}
                key={title}
                title={title}
                name={name}
                value={index + 1}
                onClick={() => setCurrentValue(index + 1)}
                ref={register as any}
              />
            );
          })}
        </RadioGroup>
        <RatingValueScale>
          <span data-testid={`review-horizontalGroup-${name}-min`}>
            {values[0]}
          </span>
          <span data-testid={`review-horizontalGroup-${name}-middle`}>
            {values[Math.floor(values.length * 0.5)]}
          </span>
          <span data-testid={`review-horizontalGroup-${name}-max`}>
            {values[values.length - 1]}
          </span>
        </RatingValueScale>
      </RatingGroup>
    );
  },
);

export default HorizontalRatingGroup;
